import { EventTypes, SerializedNode } from '@candulabs/craft';
import React, { useContext, useMemo, useRef } from 'react';

import { RichTextEditor } from '@candu-ai/editor-nodes/richtext-editor';
import { useLocalStorage } from 'commons/hooks';
import Node from 'craft/components/Node';
import { BuiltInComponents } from 'craft/constants';
import { CollectionContext } from 'craft/contexts';
import { CANDU_CLIPBOARD, useEditorSelector, useNodeContext } from 'craft/hooks';
import { Resolver } from 'craft/types';

import { RichTextCopy } from './RichTextCopy';

export const RichText: Resolver = (props: any) => {
  const ref = useRef<HTMLDivElement>(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, setClipboard] = useLocalStorage(CANDU_CLIPBOARD, null);
  const { id: collectionItemId } = useContext(CollectionContext);
  const { id: nodeId } = useNodeContext();

  const [focusedRichText, targetedNodeId]: [string, string] = useEditorSelector((_state, q) => {
    const focusedElements = q.getEvent(EventTypes.focused);
    return focusedElements.all();
  });
  const isNodeInFocus = useMemo(() => {
    return focusedRichText === `${nodeId}${collectionItemId ? `-${collectionItemId}` : ``}`;
  }, [focusedRichText, nodeId, collectionItemId]);

  const onCopy = (
    trees: {
      nodes: Record<string, SerializedNode>;
      rootNodeId: string;
    }[],
  ) => {
    setClipboard({ trees });
  };

  return (
    <div id={`cu-${nodeId}`} ref={ref}>
      {isNodeInFocus ? (
        <RichTextEditor
          isInCollection={!!collectionItemId}
          targetedNodeId={targetedNodeId}
          innerRef={ref}
          onCopy={onCopy}
        />
      ) : (
        <Node
          {...props}
          className="candu-rich-text-wrapper"
          data-rte-node
          css={{ position: 'relative' }}
        >
          {props.hasCopy && <RichTextCopy />}
          {props.children}
        </Node>
      )}
    </div>
  );
};

RichText.craft = {
  name: BuiltInComponents.RichTextEditor,
  isCanvas: true,
};
